module.exports = __webpack_public_path__ + "img/approved.3e69b99c.svg";